import { useTranslation } from "react-i18next";
import { Badge, BadgeVariant } from "@rentablo/components";
import { GoalStatus } from "../utils/goalStatus";

const variants: Record<GoalStatus, BadgeVariant> = {
  onTrack: "success",
  behindPlan: "warning",
  atRisk: "error",
};

export const GoalStatusBadge = ({ status }: { status: GoalStatus }) => {
  const { t } = useTranslation();

  return (
    <Badge variant={variants[status]} flex="none" whiteSpace="nowrap">
      {t(`goals.status.${status}`)}
    </Badge>
  );
};
